import React from 'react'

import { valueOrEmptyString } from 'helpers/strings'
import { getAddressText } from 'helpers/location'

import Input from './Input'
import Label from './Label'
import LocationInput from './LocationInput'

const InputLocation = ({ autoFocus, userData, onLocationChange, onAddressChange }) => (
  <div className="text-white">
    <Label>Location</Label>
    <div className="mb-5">
      <LocationInput
        name="location"
        label=""
        placeholder="Home Base"
        saveLocation={locationResult => {
          const {
            location: { formatted_address: location },
            lat: geoLat,
            lng: geoLng,
          } = locationResult
          onLocationChange({
            location,
            geoLat,
            geoLng,
          })
        }}
        defaultAddress={userData.location || ''}
        autoFocus={autoFocus}
      />
      <br />
      <div className="uppercase font-medium font-ownersWide mb-2">Mailing Address</div>
      <LocationInput
        name="userAddress"
        label=""
        placeholder="Address"
        searchType="address"
        saveLocation={locationResult => {
          const { components } = locationResult
          onAddressChange(components)
        }}
        defaultAddress={getAddressText(userData.userAddress) || ''}
        autoFocus={autoFocus}
        required={false}
      />
      <Input
        type="text"
        name="appt"
        classNames={{ container: 'mt-2.5' }}
        value={valueOrEmptyString(userData.userAddress?.appt)}
        placeholder="Apartment / Suite etc. (optional)"
        onChange={e => onAddressChange({ appt: e.target.value })}
      />
    </div>
  </div>
)

export default InputLocation
